// Regex
export const VALID_EMAIL_REGEX = /\S+@\S+\.\S+/;
export const VALID_PASSWORD_REGEX =
	/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

// Auth
export const INVALID_CREDENTIALS = 'Invalid credentials';
// Exact backend message text (portal-be PR #13) — matched by string, this API has no error codes.
export const TEMP_PASSWORD_MUST_CHANGE =
	'Temporary password must be changed before you can log in.';
export const TEMP_PASSWORD_EXPIRED =
	'Temporary password expired. Contact your administrator for a new one.';
export const INVALID_EMAIL = 'Invalid email';
export const INVALID_PASSWORD =
	'Invalid password. Password must contain a minimum of 8 characters and include at least one uppercase letter, one lowercase letter, one digit and one special character';
export const PASSWORDS_DO_NOT_MATCH = 'Passwords must match';

export const WRONG_EMAIL = 'Wrong email';
